import { defineStore } from "pinia"
import type { Transaction } from "@/model/DataModel"
import { UseRootStore } from "@/model/RootStore"
import type { View } from "@/types"
import * as apiClient from "@/utils/ApiClient"

type FetchByViewOptions = {
	limit: number
	offset: number
}

export const useTransactionStore = defineStore("transaction", () => {
	const rootStore = UseRootStore()

	async function fetchByView(
		view: View,
		options: FetchByViewOptions
	): Promise<{ items: Transaction[]; total: number }> {
		return await apiClient.searchTransactionsByView(rootStore.userApiToken, view, options.limit, options.offset)
	}

	return {
		fetchByView,
	}
})
